<div *ngIf="showLegend && !displayMessage" class="status-legend flex-row">
    <div class="grow-4"></div>
    <div class="status flex-row">
        <div class="operative"></div>
        <div class="status-name">Operativo Interior</div>
    </div>

    <div class="status flex-row">
        <div class="delay"></div>
        <div class="status-name">Demora</div>
    </div>

    <div class="status flex-row">
        <div class="reserve"></div>
        <div class="status-name">Operativo Exterior</div>
    </div>

    <div class="status flex-row">
        <div class="out-of-service"></div>
        <div class="status-name">No operativo</div>
    </div>
    <div class="grow-4"></div>
</div>

<div
    class="chart-container"
    #chartTarget
    [ngClass]="{ 'd-none': !displayMessage }"
></div>
